export default __webpack_public_path__ + "static/spark-39b7151614f57c033233ed8efa157978.png";